module.exports = __webpack_public_path__ + "img/honor3.587016f5.png";